import { Icon } from '@aibees/shared/components';
import { useBoolean } from '@aibees/shared/hooks';
import { classnames } from '@aibees/shared/utils';
import { Stack, Typography } from '@mui/material';
import { memo, useState } from 'react';
import * as Styled from './styles';
import * as SX from './sx';
import type { SearchActivityAlertProps as Props } from './types';

export const SearchActivityAlert = memo(({ className }: Props) => {
  const [close, setClose] = useState<boolean>(true);
  const limitReachedDialogState = useBoolean(false);

  /*useEffect(() => {
    if (true) { // TODO MOHAMMAD use API for this condition
      limitReachedDialogState.onTrue()
    }
  }, []);*/

  return (
    <>
      {/* <SearchLimitAlertDialog state={limitReachedDialogState} /> */}
      <Styled.Wrapper
        className={classnames('SearchActivityAlert', className)}
        sx={SX.root(close)}
      >
        <Stack direction="row" justifyContent="flex-end">
          <Icon
            name="close"
            size={16}
            sxx={SX.closeIcon}
            onClick={() => setClose(true)}
          />
        </Stack>
        <Typography sx={SX.title}>
          Your monthly search activity is at 95%
        </Typography>
        <Typography sx={SX.description}>
          To maintain security and enhance your experience, we regulate search
          activity based on your search-to-credits ratio.
        </Typography>
      </Styled.Wrapper>
    </>
  );
});

SearchActivityAlert.displayName = 'SearchActivityAlert';
